import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../../select-base';

@Component({
  selector: 'app-exp-select',
  templateUrl: './exp-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExpenseAccountSelectComponent),
      multi: true
    }
  ]
})
export class ExpenseAccountSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
    this.valueField = '';
  }

  @Input() labelType: 'code' | 'name' | 'full' = 'full';

  getLabel(item: any) {
    if (item) {
      if (this.labelType === 'code') return item?.code;
      else if (this.labelType === 'name') return item?.name;
      return `${item?.code} - ${item?.name}`;
    }
    return '';
  }

  getUrl(searchValue: string): string {
    let url = `api/accountcodes/search?$top=50&$skip=0&$filter=IsActive eq true and Type eq 'EXP'`;
    if (searchValue && searchValue.trim()) {
      url = `${url}&keyword=${encodeURIComponent(searchValue.trim())}`;
    } else {
      url = `${url}&$orderby=code asc`;
    }
    return url;
  }
}
